(() => {
  'use strict';
  const setLoaded = () => document.documentElement.classList.add('zavo-v6-loaded');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setLoaded, { once: true });
  else setLoaded();

  // Keep Shopify editor re-renders clean and avoid stale body locks after a section reload.
  document.addEventListener('shopify:section:load', () => {
    document.documentElement.style.overflow = '';
  });
})();
